import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { decryptToken } from "../utils/getToken";

const SettingsBankAndSign = ({ main_id }) => {
    const [bankData, setBankData] = useState({
        bank_name: "",
        ifsc_code: "",
        account_no: "",
        bank: "",
    });
    const url = API_BASE_URL;
    const token = decryptToken("accessToken") || ""
    const [company, setCompany] = useState("")
    const [signFile, setSignFile] = useState(null);
    const [signPreview, setSignPreview] = useState(null);

    const handleBankChange = (e) => {
        setBankData({ ...bankData, [e.target.name]: e.target.value });
    };

    const handleSignChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setSignFile(file);
        setSignPreview(URL.createObjectURL(file));
    };

    const fetchBankDetails = async () => {
        try {
            const response = await fetch(`${url}/bank-detail/get`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            setBankData({
                bank_name: res.data.bank_name || "",
                ifsc_code: res.data.ifsc_code || "",
                account_no: res.data.account_no || "",
                bank: res.data.bank || ""
            })
        } catch (error) {
            console.error(error)
        }
    }

    const fetchAuthoritySign = async () => {
        try {
            const response = await fetch(`${url}/authority-sign/get`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const res = await response.json();

            const normalizedBaseUrl = url.replace(/\/+$/, "");

            const cleanPath = res.data.sign.replace(/^\/?uploads\//, "");

            setSignPreview(`${normalizedBaseUrl}/${cleanPath}`);
            setCompany(res.data.company_name || "");
        } catch (error) {
            console.error(error);
        }
    };



    const saveBankDetails = async () => {
        try {
            const res = await fetch(`${url}/bank-detail`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ ...bankData }),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            fetchBankDetails();
            toast.success("Bank details saved successfully");
        } catch (err) {
            toast.error(err.message || "Failed to save bank details");
        }
    };

    const saveAuthoritySign = async () => {
        // if (!signFile) {
        //     toast.error("Please select signature image");
        //     return;
        // }

        const formData = new FormData();
        formData.append("sign", signFile);
        // formData.append("main_id", main_id);
        formData.append("company_name", company || "");

        try {
            const res = await fetch(`${url}/authority-sign`, {
                method: "POST",
                body: formData,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = await res.json();
            console.log(res)
            if (res.status === 409) {
                handleSaveAlready();
            }
            if (!res.ok) throw new Error(data.message);
            fetchAuthoritySign();
            toast.success("Signature saved successfully");
        } catch (err) {
            toast.error(err.message || "Failed to save signature");
        }
    };

    const handleSaveAlready = async () => {
        const formData = new FormData();
        formData.append("sign", signFile);
        // formData.append("main_id", main_id);
        formData.append("company_name", company || "");

        try {
            const res = await fetch(`${url}/authority-sign`, {
                method: "PUT",
                body: formData,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = await res.json();
            // if (!res.ok) throw new Error(data.message);
            fetchAuthoritySign();
            toast.success("Signature saved successfully");
        } catch (err) {
            toast.error(err.message || "Failed to save signature");
        }
    }

    useEffect(() => {
        fetchBankDetails();
        fetchAuthoritySign();
    }, [])

    return (
        <div className="bankdetails-wrapper">
            {/* BANK DETAILS */}
            <div className="bankdetails-card">
                <h3 className="bankdetails-title">Bank Details</h3>

                <div className="bankdetails-form">
                    <div>
                        <label>Bank Name</label>
                        <input name="bank_name" value={bankData.bank_name} onChange={handleBankChange} />
                    </div>

                    <div>
                        <label>IFSC Code</label>
                        <input name="ifsc_code" value={bankData.ifsc_code} onChange={handleBankChange} />
                    </div>

                    <div>
                        <label>Account Number</label>
                        <input name="account_no" value={bankData.account_no} onChange={handleBankChange} />
                    </div>

                    <div>
                        <label>Branch / Bank</label>
                        <input name="bank" value={bankData.bank} onChange={handleBankChange} />
                    </div>
                </div>

                <button className="bankdetails-btn" onClick={saveBankDetails}>
                    Save Bank Details
                </button>
            </div>

            {/* AUTHORITY SIGN */}
            <div className="bankdetails-card">
                <h3 className="bankdetails-title">Authority Signature</h3>

                {signPreview && (
                    <img src={signPreview} alt="Signature Preview" className="bankdetails-sign-preview" />
                )}

                <input
                    type="file"
                    accept="image/*"
                    className="bankdetails-file"
                    onChange={handleSignChange}
                />

                <input
                    type="text"
                    name="company"
                    className="companyauthority-name"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Enter Company Name"
                />

                <button className="bankdetails-btn" onClick={saveAuthoritySign}>
                    Save Signature
                </button>
            </div>
        </div>
    );
};

export default SettingsBankAndSign;
